import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const purchaseMasterService = {
  async getPurchaseMasters(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/purchase-master", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActivePurchaseMasters() {
    try {
      const response = await apiClient.get("/purchase-master/active");
      const payload = response?.data || {};
      const items = toArray(payload?.data || payload);
      
      return {
        items,
        meta: {
          page: 1,
          limit: items.length,
          total: items.length,
          totalPages: 1,
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getPurchaseMasterById(id) {
    if (!id) throw new Error("Purchase Master ID is required");
    try {
      const response = await apiClient.get(`/purchase-master/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteBLContainer(id) {
    if (!id) throw new Error("BL Container ID is required");
    try {
      const response = await apiClient.delete(`/containers/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default purchaseMasterService;
